import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTable: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTable"><Path d="M20.5 3.5H21V3H20.5V3.5ZM20.5 20.5V21H21V20.5H20.5ZM3.5 3.5V3H3V3.5H3.5ZM3.5 20.5H3V21H3.5V20.5ZM20.5 3.5H20V20.5H20.5H21V3.5H20.5ZM3.5 3.5V4H20.5V3.5V3H3.5V3.5ZM3.5 20.5H4V3.5H3.5H3V20.5H3.5ZM20.5 20.5V20H3.5V20.5V21H20.5V20.5Z" fill="currentColor"/><Path d="M9.5 3.5V9.5V20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 9.5H9.5H20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTable;
